import {Notifier} from "Core/Common/Notifier";

import {NewThirdPartyDataRoleComponent} from "Core/Controls/FieldSecurity/Components/DataRole/NewDataRole/NewThirdPartyDataRoleComponent";

import {DataRoles} from "Core/Controls/FieldSecurity/Shared/Enums/DataRoles";
import {UserTypes} from "User/UserManager";

export class NewPORoleComponent extends NewThirdPartyDataRoleComponent {
	constructor() {
		super(DataRoles.Instance.PO);
	}

	AfterRender() {
		this.LoadUsers(UserTypes.Guest)
			.then(users => this.UsersLoaded(users))
			.fail(error => new Notifier().Failed(error.message));
	}
}